import type { Tier } from "../../types";

const getTierLevel = (tier: Tier, points = 0) => {
  const milestones = tier.milestones ?? [];
  const reached = milestones.filter(
    (milestone) => Number(milestone.points) <= points,
  ).length;

  return {
    milestones,
    reached,
    level: Math.max(reached, 1),
    next: milestones[reached],
    locked: points < (tier.points ?? 0),
  };
};

export default getTierLevel;
